import { EventBusMessage } from '../util/event-bus-util'
import { logger } from '../util/logger'

export enum GoogleAnalyticsEventCategory {
  REGISTRATION = 'registration',
}

export enum GoogleAnalyticsEventAction {
  SUCCESS = 'success',
  INITIATED = 'initiated',
  COMPLETE = 'complete',
}

export type GoogleAnalyticsProperties = {
  category?: GoogleAnalyticsEventCategory
  action?: GoogleAnalyticsEventAction
  label?: string[]
}

export enum GoogleAnalyticsMethod {
  EVENT = 'event',
  CONFIG = 'config',
}

export enum GoogleAnalyticsEvent {
  LEAD = 'Lead',
  COMPLETE_REGISTRATION = 'CompleteRegistration',
}

export type GoogleAnalyticsMessage = {
  methodName: GoogleAnalyticsMethod
  eventName?: GoogleAnalyticsEvent
  properties?: GoogleAnalyticsProperties
  callback?: (response: any) => any
}

export const googleAnalyticsService = {
  _push: (params: { googleAnalyticsMessage: GoogleAnalyticsMessage }): void => {
    const { googleAnalyticsMessage } = params
    const { methodName, eventName, properties, callback } = googleAnalyticsMessage
    const payload = [methodName, eventName, properties, callback].filter(Boolean)
    window.gtag(...payload)
  },

  sendUserCreated: (_: { message: EventBusMessage }): void => {
    const googleAnalyticsMessage = {
      methodName: GoogleAnalyticsMethod.EVENT,
      eventName: GoogleAnalyticsEvent.LEAD,
      properties: {
        category: GoogleAnalyticsEventCategory.REGISTRATION,
        action: GoogleAnalyticsEventAction.SUCCESS,
      },
    }
    googleAnalyticsService._push({ googleAnalyticsMessage })
  },
  sendRegistrationCompleted: (_: { message: EventBusMessage }): void => {
    const googleAnalyticsMessage = {
      methodName: GoogleAnalyticsMethod.EVENT,
      eventName: GoogleAnalyticsEvent.COMPLETE_REGISTRATION,
      properties: {
        category: GoogleAnalyticsEventCategory.REGISTRATION,
        action: GoogleAnalyticsEventAction.COMPLETE,
      },
    }
    googleAnalyticsService._push({ googleAnalyticsMessage })
  },
}
